import { render } from "./StatsChartTitleWithDescription.vue?vue&type=template&id=04b7f16d&scoped=true&ts=true"
import script from "./StatsChartTitleWithDescription.vue?vue&type=script&lang=ts"
export * from "./StatsChartTitleWithDescription.vue?vue&type=script&lang=ts"

import "./StatsChartTitleWithDescription.vue?vue&type=style&index=0&id=04b7f16d&scoped=true&lang=css"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04b7f16d"]])

export default __exports__